module.exports = __webpack_public_path__ + "assets/LogoPacksScreen.c069f9500aef06e1c5ae920210b3d5c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/logo/LogoPacksScreen.png
// module id = 754
// module chunks = 0